import React from "react";
import "./style.scss";

export default function ActivityPoints({
  children,
  desktopBig = false,
  className = "",
  customPointsCopy = "",
}) {
  return (
    <div
      className={`activity-points-component ${
        desktopBig ? "desktop-bigger" : ""
      } ${className}`}
    >
      <div className="inner-content">
        <span className="points">+{children}</span>
        <span className="value">{customPointsCopy ? customPointsCopy : "Punkte"}</span>
      </div>
    </div>
  );
}
